import {
  WORKER_CONFIG_FETCH_WORKER_DATA_BEGIN,
  WORKER_CONFIG_FETCH_WORKER_DATA_SUCCESS,
  WORKER_CONFIG_FETCH_WORKER_DATA_FAILURE,
  WORKER_CONFIG_FETCH_WORKER_DATA_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import moment from 'moment';
import { enqueueSnackbar, enqueueWarning, enqueueFailedRequestWarning} from '../../home/redux/snackActions'
import {makeDictionary} from '../../common/util'


function removeElement(obj, keyToRemove)
{
  let result = {};
  
  Object.keys(obj).forEach(k => {
    //compare with == because k is string and keyToRemove number. Why?
    if (k == keyToRemove) return;
    result[k] = obj[k];
  })
  return result;
}


function makeFilterDictionary(arr)
{
  let result = {};
  console.log({arr});
  Object.values(arr).forEach(el => result[el.name] = true);
  return result;
}

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchWorkerData(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: WORKER_CONFIG_FETCH_WORKER_DATA_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      let initialStateData = {};
      let dataRequests = [
                  axios.get("/api/plans"),
                  axios.get("/api/workers"),
                  axios.get("/api/seasons"),
                  axios.get("/api/roles"),
                  axios.get("/api/locations"),
                  axios.get("/api/WorkerDateAvailability"),
                  axios.get("/api/WorkerLocationAvailability"),
                  axios.get("/api/WorkerLocationFrequency"),
                  axios.get("/api/WorkerRoleFrequency"),
                  axios.get("/api/WorkerRoleAvailability"),
                  axios.get("/api/WorkerAvailabilityFrequency"),
                  axios.get("/api/WorkerPairs"),
                  axios.get("/api/WorkerSurvey/statistics"),
                  
                ];
                if (args.fetchProperties)
                {
                  dataRequests.push(axios.get("/api/WorkerProperties/"+args.workerId));
                  dataRequests.push(axios.get("/api/GenericWorkerCostDefinitions/forworker/"+args.workerId));
                  dataRequests.push(axios.get("/api/properties"));
                }
      
      let numPending = dataRequests.length;
      
      let failed = false;

      dataRequests.forEach(r => {console.log("foreach loopinner ");r.then(
        (res) => {
          console.log("foreach loop");
          numPending--;
          let data = res.data;
          
          Object.keys(data).forEach(k => 
            {
              if (Array.isArray(data[k]))
                initialStateData[k] = makeDictionary(data[k]);
              else
                initialStateData[k] = data[k];
            }
          );
          console.log({numPending, initialStateData});
          if (numPending === 0)
          {
            dispatch({
              type: WORKER_CONFIG_FETCH_WORKER_DATA_SUCCESS,
              data: initialStateData,
              workerId: args.workerId
            });
            resolve(initialStateData);
          }
          

        },
        
        (err) => {
          console.log({err})
            dispatch(enqueueFailedRequestWarning('Failed fetching data.',err));
          if (failed) return;
          failed = true;
          
          dispatch({
            type: WORKER_CONFIG_FETCH_WORKER_DATA_FAILURE,
            data: { error: err },
          });
          
          reject(err);
        },
      )});
        

    return promise;
  });
}
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchWorkerDataError() {
  return {
    type: WORKER_CONFIG_FETCH_WORKER_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_FETCH_WORKER_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchWorkerDataPending: true,
        fetchWorkerDataError: null,
      };

    case WORKER_CONFIG_FETCH_WORKER_DATA_SUCCESS:
      // The request is success
      let newState = {
        ...state,
        fetchWorkerDataPending: false,
        fetchWorkerDataError: null,
      };
      Object.keys(action.data).forEach(k => 
        newState[k] = action.data[k]);

      newState = {...newState, 
      filterables: {...newState.filterables,
        roles: makeFilterDictionary(newState.allRoles),
        locations: makeFilterDictionary(newState.allLocations),
        },
        genericWorkerCostDefinitions : newState.genericWorkerCostDefinitions ? Object.values(newState.genericWorkerCostDefinitions)
          .filter(gwc=>gwc.workerId === action.workerId)
          .map(gwc => removeElement(removeElement(gwc, "workerId"), "id")) //we're posting back simply a list of generic cost, they are all replaced in the database then
          : []
      };
      return newState;

    case WORKER_CONFIG_FETCH_WORKER_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchWorkerDataPending: false,
        fetchWorkerDataError: action.data.error,
      };

    case WORKER_CONFIG_FETCH_WORKER_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchWorkerDataError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/fetchWorkerData.js